var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, Box, Typography, OptimizeImage } from '@telus-uds/components-web';
import styled from 'styled-components';
import RichText from '../RichText/RichText';
export var MarketingCard = function (_a) {
    var imageSrc = _a.imageSrc, imageAlt = _a.imageAlt, title = _a.title, description = _a.description;
    return (_jsx(StyledFullHeight, { "data-testid": "marketing-card", children: _jsxs(Card, { fullBleedContent: {
                alt: imageAlt,
                position: { xs: 'top' },
                content: _jsx(OptimizeImage, { contentfulAssetUrl: imageSrc, alt: imageAlt })
            }, variant: { padding: 'custom' }, tokens: {
                paddingTop: 16,
                paddingBottom: 16,
                paddingLeft: 16,
                paddingRight: 16
            }, children: [_jsx(Typography, { block: true, variant: { size: 'h3' }, children: title }), _jsx(Box, { top: 2, children: _jsx(RichText, { content: description }) })] }) }));
};
export default MarketingCard;
// ---------------------------- Styled Components ---------------------------- //
export var StyledFullHeight = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 100%;\n  & > div {\n    height: 100%;\n\n    & > div {\n      justify-content: left !important;\n    }\n\n    & > div > div {\n      justify-content: flex-end !important;\n    }\n  }\n"], ["\n  height: 100%;\n  & > div {\n    height: 100%;\n\n    & > div {\n      justify-content: left !important;\n    }\n\n    & > div > div {\n      justify-content: flex-end !important;\n    }\n  }\n"])));
var templateObject_1;
